module.exports = __webpack_public_path__ + "img/thumb_03.d54cabc6.jpg";